// This icon file is generated automatically.
var PtoStarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M28.38 11.03l-7.94-1.15L16.9 2.7a1 1 0 00-1.8 0l-3.54 7.2-7.94 1.14a1 1 0 00-.55 1.71l5.74 5.6-1.36 7.9A1 1 0 008.9 27.3l7.1-3.73 7.1 3.73c.2.1.42.14.63.1a1 1 0 00.82-1.15l-1.36-7.9 5.74-5.6a1 1 0 00-.55-1.7zm-7.6 6.52l1.12 6.57-5.9-3.1-5.9 3.1 1.13-6.57-4.78-4.65 6.6-.96L16 5.96l2.95 5.98 6.6.96-4.78 4.65z", "fill-rule": "nonzero" } }] }, "name": "pto-star", "theme": "outlined" };
export default PtoStarOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoStarOutlined.js
// module id = 3926
// module chunks = 0